/* eslint-disable camelcase */
import { EventDispatcher, fadeIn, fadeOut, hideElement, initGoogleMaps, isMobileView, isTabletView, l, lLink, lc, qs, qsa, setUrlParameter, showElement } from '@utils/toolbox';
import { ConnectApi } from '@js/plugins/connectApi';
import { dateFormatYMD } from '@utils/dateFns';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { Modal } from '@components/modal';
let resultModal;
export class PriceHunterMap {
	constructor (options = {}, element = '#map') {
		this.element = qs(element);
		if (!this.element) {
			console.error('No map element found');
			return;
		}
		this.map = null;
		this.data = null;
		this.showingList = {};
		this.hasInit = false;
		this.firstTime = true;
		this.options = {
			center: { lat: parseFloat(js_params.module.PriceHunter.latitude), lng: parseFloat(js_params.module.PriceHunter.longitude) },
			zoom: Number(js_params.module.PriceHunter.zoom),
			gestureHandling: 'greedy',
			disableDefaultUI: true,
			zoomControl: false,
			restriction: {
				latLngBounds: {
					north: 85,
					south: -85,
					west: -180,
					east: 180
				},
				strictBounds: false
			},
			isFractionalZoomEnabled: isMobileView() || isTabletView(),
			minZoom: 1,
			maxZoom: 11,
			...options
		};

		this.init();
	}

	reset () {
		window.pricehunter_map.map.setCenter(window.pricehunter_map.options.center);
		window.pricehunter_map.map.setZoom(window.pricehunter_map.options.zoom);
	}

	updateURLParameters () {
		// Get the current map center and zoom
		const center = this.map.getCenter();
		const lat = center.lat().toFixed(6); // toFixed for fewer decimals
		const lng = center.lng().toFixed(6);
		const zoom = this.map.getZoom();

		// Update the browser's URL without reloading the page
		let url = window.location.href;
		url = setUrlParameter(url, 'lat', lat);
		url = setUrlParameter(url, 'lng', lng);
		url = setUrlParameter(url, 'zoom', zoom);

		window.history.replaceState({}, '', url);
	}


	getExtendedBounds (overlay, bounds) {
		// With _mapBoundsEnlargePixels we add some extra space surrounding the map
		// change this value until you get the desired size
		const _mapBoundsEnlargePixels = 2;

		const projection = overlay.getProjection();
		// const bounds = map.getBounds();

		// Turn the bounds into latlng.
		const tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
		const bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());

		// Convert the points to pixels and extend out
		const trPix = projection.fromLatLngToDivPixel(tr);
		trPix.x = trPix.x + _mapBoundsEnlargePixels;
		trPix.y = trPix.y - _mapBoundsEnlargePixels;

		const blPix = projection.fromLatLngToDivPixel(bl);
		blPix.x = blPix.x - _mapBoundsEnlargePixels;
		blPix.y = blPix.y + _mapBoundsEnlargePixels;

		// Convert the pixel points back to LatLng
		const ne = projection.fromDivPixelToLatLng(trPix);
		const sw = projection.fromDivPixelToLatLng(blPix);

		// Extend the bounds to contain the new bounds.
		bounds.extend(ne);
		bounds.extend(sw);

		return bounds;
	}


	init () {
		if (this.hasInit) {
			return;
		}

		this.map = new google.maps.Map(this.element, this.options);
		this.infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });

		this.markerClusterer ??= new MarkerClusterer({
			map: this.map,
			renderer: {
				render (cluster, stats) {
					// NB: we don't use the position provided by the cluster object but instead use the position of the cheapest marker in the cluster.
					const { position, markers } = cluster;
					const cheapestMarker = markers.reduce((prev, curr) => prev.data.price < curr.data.price ? prev : curr);
					return new window.PriceTag(cheapestMarker.position, cheapestMarker.data, { onClick: window.pricehunter_map.onClick }, true);
				}
			}
			// Was working with markers but not with OverlayView, unsure why
			// async onClusterClick (mapMouseEvent, cluster, map) {
			// const html = await window.pricehunter_map.getContent(cluster._cheapest);
			// this.infoWindow.setContent(html);
			// this.infoWindow.setPosition(cluster.getCenter());
			// this.infowindow.open(map, cluster._cheapest);
			// }
		});

		this.markerClusterer.algorithm.superCluster.options.radius = 70;

		this.map.addListener('idle', this.refresh);

		this.map.addListener('tilesloaded', function () {
			this.mapLoaded = true;

			EventDispatcher.dispatch('map:ready');

			if (window.pricehunter_map.refreshOnReady) {
				window.pricehunter_map.refresh(true);
				window.pricehunter_map.refreshOnReady = false;
			}
		});

		google.maps.event.addDomListener(window, 'resize', function () {
			const center = window.pricehunter_map.map.getCenter();
			google.maps.event.trigger(window.pricehunter_map.map, 'resize');
			window.pricehunter_map.map.setCenter(center);
		});

		EventDispatcher.addEventListener('pricehunterMapDataFetched', this.onDataUpdated);

		EventDispatcher.addEventListener('mapToggleComplete', function (data) {
			google.maps.event.trigger(window.pricehunter_map.map, 'resize');
		});

		this.hasInit = true;

		this.insertDesktopNoResults();
	}

	insertDesktopNoResults () {
		const html = this.getNoResultsHtml(true);
		this.element.insertAdjacentHTML('afterend', html);
	}


	onDataUpdated (data) {
		clearOverlays();
		// Sort by cheapest
		window.pricehunter_map.data = window.pricehunter_map.sortByCheapest(data);

		// Reset markers
		window.pricehunter_map.showingList = {};
		window.pricehunter_map.markerClusterer.clearMarkers();

		const { templateData } = window.pricehunter_map.parseResponse({ rows: data.slice(0, 10) });
		if (qs('.summary .summary__cheapest')) {
			qs('.summary .summary__cheapest').innerHTML = window.pricehunter_map.getTable(templateData, true);
		}
		fadeIn('.summary__cheapest');

		if (window.pricehunter_map.map.mapLoaded) {
			window.pricehunter_map.refresh(true);
		} else {
			window.pricehunter_map.refreshOnReady = true;
		}
	}

	sortByCheapest (data) {
		return data.sort(({ price: a }, { price: b }) => a - b);
	}

	centerOnBounds (latlngArr) {
		let bounds = new google.maps.LatLngBounds();

		// window.pricehunter_map.markerClusterer.clusters.forEach((cluster) => {
		// 	bounds.extend(cluster.marker.position);
		// });
		latlngArr.forEach((latlng) => {
			bounds.extend(latlng);
		});

		bounds = window.pricehunter_map.getExtendedBounds(window.pricehunter_map.markerClusterer, bounds);

		window.pricehunter_map.map.fitBounds(bounds);
	}

	refresh (fitbounds) {
		if (!window.pricehunter_map.data) {
			return;
		}
		window.pricehunter_map.element.style.visibility = 'visible';

		const click_options = { onClick: window.pricehunter_map.onClick };
		const map_bounds = window.pricehunter_map.map.getBounds();
		let point = window.pricehunter_map.map.getProjection().fromLatLngToPoint(map_bounds.getNorthEast());
		const scale = 2 ** window.pricehunter_map.map.getZoom();
		const pixelOffset = new google.maps.Point(Math.floor(point.x * scale), Math.floor(point.y * scale));

		pixelOffset.y -= 50;

		point = new google.maps.Point(pixelOffset.x / scale, pixelOffset.y / scale);

		const latlng2 = window.pricehunter_map.map.getProjection().fromPointToLatLng(point);

		map_bounds.extend(latlng2);
		const addedMarkers = [];
		const latlngArr = [];
		const removedMarkers = [];
		let latlng;
		let atLeastOneMarkerInBounds = false;

		for (let i = 0; i < window.pricehunter_map.data.length; ++i) {
			const marker = window.pricehunter_map.data[i];
			latlng = new google.maps.LatLng(Number(marker.lat), Number(marker.lng));
			latlngArr.push(latlng);

			const isInList = window.pricehunter_map.showingList[marker.outbound_to];
			const isInBounds = map_bounds.contains(latlng);
			if (isInBounds && !atLeastOneMarkerInBounds) {
				atLeastOneMarkerInBounds = true;
			}
			if (isInBounds && !isInList) {
				window.pricehunter_map.showingList[marker.outbound_to] = new window.PriceTag(latlng, marker, click_options);
				addedMarkers.push(window.pricehunter_map.showingList[marker.outbound_to]);
			} else if (!isInBounds && isInList) {
				window.pricehunter_map.showingList[marker.outbound_to].remove();
				removedMarkers.push(window.pricehunter_map.showingList[marker.outbound_to]);
				delete window.pricehunter_map.showingList[marker.outbound_to];
			}
		}

		window.pricehunter_map.markerClusterer.addMarkers(addedMarkers, false);
		window.pricehunter_map.markerClusterer.removeMarkers(removedMarkers, false);

		if (window.pricehunter_map.firstTime || fitbounds == true) {
			window.pricehunter_map.firstTime = false;

			if (latlngArr.length > 0 && latlngArr.length < 10) {
				window.pricehunter_map.centerOnBounds(latlngArr);
			} else if (!atLeastOneMarkerInBounds) {
				window.pricehunter_map.reset();
			} else if (latlngArr.length === 1) {
				window.pricehunter_map.map.setZoom(11);
				window.pricehunter_map.map.setCenter(latlngArr[0]);
			}
		}
		EventDispatcher.dispatch('pricehunter:refreshed');

		pricehunter_map.updateURLParameters();
	}

	async onClick (e, bubble) {
		e.preventDefault();
		const { header, body } = await window.pricehunter_map.getContent(bubble);
		const footer = `
<button class="js-close-modal abBtn abBtn--block">
	<span>${l('global.simplePhrases.close')}</span>
</button>
`;
		resultModal = new Modal({
			header: header,
			body: body,
			footer: footer,
			className: 'modal--priceHunter',
			hideFooter: false,
			hideOnSwipe: true,
			id: 'priceHunterModal',
			onClose: () => {
				resultModal = null;
			},
			resetScroll: true
		});

		resultModal.open();

		// Modal close button
		qs('.modal__header .icon-circle-cross').addEventListener('click', () => {
			resultModal.close();
		});

		return false;
	}

	getNoResultsHtml (isHidden = false) {
		return `
<div class="noResults" ${isHidden ? 'style="display: none"' : ''}>
	<div class="noResults__content">${l('showresult.info.allResultsAreFiltered')}</div>
	<button class="noResults__action abBtn abBtn--whiteBlue" data-action="filters-clear">
		${l('showresult.filter.removeBtnText')}
	</button>
</div>
`;
	}


	getTable (data, isExtended = false) {
		const { rows } = data;
		if (!rows.length) {
			return this.getNoResultsHtml();
		}


		const headerValues = isExtended
			? [l('pricehunter.map.price'), l('pricehunter.map.airports'), l('global.simplePhrases.dates', 'Datum')]
			: [l('pricehunter.map.price'), l('global.simplePhrases.From', 'Departure Airports'), l('pricehunter.map.outbound', 'Utresa'), l('pricehunter.map.inbound', 'Hemresa')];


		const bodyKeys = isExtended
			? ['departureArrivalText', 'departureArrivalDates']
			: ['departureText', 'formattedLeaveDate', 'formattedHomeDate'];

		return `
<table class="prices-tbl">
	<thead>
		<tr>
			${headerValues.map(text => `<th>${text}</th>`).join('')}
		</tr>
	</thead>
	<tbody>
	${rows.map((rows) => {
			return `
		<tr>
			<td><a class="price" href="${rows.link}">${rows.price}</a></td>
			${
				bodyKeys.map(key =>
					`<td><a href="${rows.link}">${rows[key]}</a></td>`
				).join('')
			}
		</tr>
		`;
		}).join('')}
	</tbody>
</table>
`;
	}

	parseResponse (response) {
		const { localizedtocity, outbound_to, tocountry, localizedtocountry, to_city_id, to_country_id } = response.rows?.[0] || {};

		const rows = response.rows.map((row) => {
			return {
				link: window.pricehunter.getShowresultUrl(row),
				price: lc(row.price),
				departureArrivalText: `${row.fromname || row.localizedfromcity || row.fromcity}<br>${row.localizedtocity}, ${row.localizedtocountry}`,
				departureText: `${row.fromname || row.localizedfromcity || row.fromcity}`,
				departureArrivalDates: `${dateFormatYMD(new Date(row.leavedate))}<br> ${dateFormatYMD(new Date(row.homedate))}`,
				formattedLeaveDate: dateFormatYMD(new Date(row.leavedate)),
				formattedHomeDate: dateFormatYMD(new Date(row.homedate)),
				outbound_from: row.outbound_from,
				outbound_to: row.outbound_to,
				airports: row.outbound_from + ' - ' + row.outbound_to,
				localizedfromcity: row.localizedfromcity,
				localizedtocity: row.localizedtocity,
				tocountry: row.tocountry,
				localizedtocountry: row.localizedtocountry
			};
		});

		const templateData = {
			rows: rows
			// bottom_link: 'http://' + document.location.host + '?destcity=' + outbound_to,
			// bottom_text: l('pricehunter.map.searchMore', 'Sök fler resor till') + ' ' + localizedtocity
		};
		return {
			templateData,
			outbound_to,
			tocountry,
			localizedtocity,
			picture: `/api/destinationImage/${to_country_id}/${to_city_id}`,
			localizedtocountry,
			to_city_id,
			to_country_id
		};
	}

	getContent (bubble) {
		const data = window.pricehunter.getSearchParameters({ iatas_to: [bubble.data.iata], limit: 10 });

		return ConnectApi('PriceHunter', 'get', [data]).then((response) => {
			if (!response?.rows) {
				return l('error.search.technical');
			}
			response.rows = window.pricehunter.getFilteredResults(response.rows);
			const { templateData, outbound_to, tocountry, localizedtocity, localizedtocountry, picture } = this.parseResponse(response);

			const header = `<div class="title">${l('pricehunter.map.cheapestTo', 'Billigast till')} ${localizedtocity}, ${localizedtocountry} (${outbound_to})</div><span class="icon-circle-cross"></span>`;
			const body = `
<div class="priceHunterModal__container">
	<div class="prices">${this.getTable(templateData, false)}</div>
	${
		picture
		? `
<div class="priceHunterModal__image" style="">
	<div class="priceHunterModal__image__wrapper">
		<img src="${picture}">
		<div class="priceHunterModal__image__destination">
			<div class="priceHunterModal__image__city">
				<span>${localizedtocity}</span>
			</div>
			<div class="priceHunterModal__image__country">
				<span>${tocountry}</span>
			</div>
		</div>
	</div>
</div>`
		: ''
	}
</div>
			`;

			const fullTemplate = header + body;
			return { body, header, fullTemplate };
		});
	}
}

const __global__map_prices_overlays = [];

let pricehunter_map;

// About effect of mouse hovering over pricetags on the map
const map_prices = {
	startup: function () {
		document.body.addEventListener('click', (e) => {
			const target = e.target;
			if (target.matches('table.prices-tbl td')) {
				qs('a', target).click();
			}

			if (target.closest('.icon-maximize')) {
				qs('.map-container').classList.add('maximized');
			}

			if (target.closest('.icon-minimize')) {
				qs('.map-container').classList.remove('maximized');
			}
		});

		const close = async () => {
			await fadeOut('.filters-top');
			document.body.classList.remove('modal-open');
			qs('#close-modal').innerHTML = l('global.simplePhrases.close');
			window.scrollTo(0, 0);
		};

		if (qs('[data-action="filters-close"]')) {
			qs('[data-action="filters-close"]').addEventListener('click', () => {
				close();
			});

			qs('.filters-top').addEventListener('click', (e) => {
				if (e.target.id !== 'filters-top' || !isMobileView()) {
					return;
				}
				close();
			});

			qs('.filtersMobileActivator').addEventListener('click', function () {
				if (document.body.classList.contains('modal-open')) {
					close();
				} else {
					document.body.classList.add('modal-open');
					fadeIn('.filters-top');
				}
			});
		}


		pricehunter_map.element.addEventListener('mouseenter', function (event) {
			const { target } = event;
			// Set the z-index to 1000000 if not already set
			if (target.matches('div.price_tag')) {
				const zIndex = getComputedStyle(target).zIndex;

				if (zIndex === 1000000) {
					return;
				}

				target.dataset.zIndex = zIndex;
				target.style.zIndex = 1000000;
			} else if (target.matches('.q tr')) {
				target.classList.add('hovered');
			}
		}, true); // Note: useCapture = true


		pricehunter_map.element.addEventListener('mouseleave', function (event) {
			const { target } = event;
			// Reset the zIndex from 1000000 if not already set
			if (target.matches('div.price_tag')) {
				const zIndex = target.dataset.zIndex;
				target.style.zIndex = zIndex;
				target.removeAttribute('data-z-index');
			} else if (target.matches('.prices-tbl tr')) {
				target.classList.remove('hovered');
			}
		}, true); // Note: useCapture = true
	}
};

function clearOverlays () {
	while (__global__map_prices_overlays[0]) {
		__global__map_prices_overlays.pop().setMap(null);
	}
}

// Callback function once the Maps JavaScript API is loaded and ready (c.f. footer script)
export function initPriceHunterMap (options = {}, element = '#map') {
	if (pricehunter_map) {
		return pricehunter_map;
	}

	return new Promise((resolve) => {
		initGoogleMaps(js_params.module.PriceHunter.googleApiKey, () => {
			pricehunter_map = new PriceHunterMap(options, element);
			window.pricehunter_map = pricehunter_map;
			map_prices.startup();
			window.PriceTag = class extends google.maps.OverlayView {
				constructor (position, data, options = {}) {
					super();

					this.position = position;
					this.data = data;

					this.data.city = this.data.localizedtocity || this.data.city;
					this.data.iata ??= this.data.outbound_to;

					// this.setMap(window.pricehunter_map.map); // this is set by markerClusterer
					__global__map_prices_overlays.push(this);

					if (options?.onClick) {
						this.onClick = options.onClick;
					}
				}

				onAdd () {
					const div = document.createElement('div');


					div.classList.add('price_tag');
					div.style.zIndex = 999999 - parseInt(this.data.price);
					div.dataset.price = this.data.price;

					const this_ = this;

					const moreInfo = this.data.toname;


					const responseId = this.data.id ? this.data.id : this.data.response_id;

					div.innerHTML = `
						<div class="arrow"></div>
						<button class="btn-close-tag icon-cross"></button>
						<div class="price">
							<a href="/${lLink('global.navigation.resultsLink')}?id=${responseId}&sorting=price" target="_blank">${lc(this.data.price)}</a>
						</div>
						<div class="info" style="display:none;">${moreInfo}</div>
					`;

					if (this.onClick) {
						div.addEventListener('click', function (e) {
							return this_.onClick(e, this_);
						});
					}

					// Set the overlay's div_ property to this DIV
					this.div_ = div;

					// We add an overlay to a map via one of the map's panes.
					// We'll add this overlay to the overlayImage pane.
					const panes = this.getPanes();
					panes.overlayMouseTarget.appendChild(div);

					if (!window.fixingColors) {
						window.fixingColors = true;
						setTimeout(() => {
							this.fixColors();
						}, 0);
					}
				}

				fixColors () {
					const priceElements = qsa('.price_tag');

					if (priceElements.length > 1) {
						let cheap = 9999999;
						let expensive = 0;

						for (const el of priceElements) {
							if (parseInt(el.dataset.price) < parseInt(cheap)) {
								cheap = el.dataset.price;
							}
							if (parseInt(el.dataset.price) > parseInt(expensive)) {
								expensive = el.dataset.price;
							}
						}

						for (const el of priceElements) {
							el.style.backgroundPositionX = (100 - (el.dataset.price - cheap) * 100 / (expensive - cheap)).toFixed(2) + '%';
						}
					}
					window.fixingColors = false;
				}

				onRemove () {
					this.div_.remove();
					this.div_ = null;
				}

				draw () {
					const overlayProjection = this.getProjection();

					const coords = overlayProjection.fromLatLngToDivPixel(this.position);

					if (this.getMap().zoom > 6) {
						showElement(this.div_.querySelector('.info'));
					} else {
						hideElement(this.div_.querySelector('.info'));
					}

					const { clientWidth, clientHeight } = this.div_;

					this.div_.style.left = coords.x - clientWidth / 2 + 'px';
					this.div_.style.top = coords.y - clientHeight + 'px';
				}

				remove () {
					const index = __global__map_prices_overlays.indexOf(this);

					if (index > -1) {
						__global__map_prices_overlays.splice(index, 1);
					}

					this.setMap(null);
				}

				getVisible () {
					return true;
				}

				getPosition () {
					return this.position;
				}
			};

			resolve(pricehunter_map);
		});
	});
}
